import React, { Component } from 'react'
import AuthenticationService from './AuthenticationService'
import { Config } from '../../Config'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import ReactTooltip from 'react-tooltip'
import { CommonConstants } from '../../Constants'
import './LoginDFA.css'
import Api from '../../Api'
import { PopulateError } from '../Common/PopulateError'
class LoginDFA extends Component {
  constructor () {
    super()
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      errorMessage: [],
      isValid: true,
      DFACode: '',
      maskedEmail: ''
    }
    this.api = new Api()
    this.authService = new AuthenticationService(Config.authBaseUrl)
  }
  componentDidMount () {
    let email = this.authService.getProfile().User_EmailAddress
    let splitString = email.split('@')
    let emailStart = splitString[0]
    let emailEnd = splitString[1]

    let maskedEmailStart = emailStart.replace(/[A-Za-z0-9]/g, '*')
    let finalMaskedEmail = maskedEmailStart + '@' + emailEnd

    this.setState({ maskedEmail: finalMaskedEmail })
  }
  handleChange (e) {
    this.setState(
      {
        [e.target.name]: e.target.value
      }
    )
  }

  handleValidation () {
    let errors = []
    const language = this.state.currentLanguage
    let DFACode = this.state.DFACode
    if (DFACode === '') {
      errors.push(t[language].InvalidIdentificationCodeBlank)
    }
    this.setState({ errorMessage: errors })
    if (errors.length > 0) {
      this.setState({ isValid: false })
      return false
    } else {
      this.setState({ isValid: true })
      return true
    }
  }
  submit (e) {
    const language = this.state.currentLanguage
    if (this.handleValidation()) {
      let dfaUrl = Config.apiBaseUrl + CommonConstants.apiUrls.checkDFACode
      let dfaData = {
        DFACode: this.state.DFACode
      }
      this.api.postData(dfaUrl, dfaData, data => {
        if (data.status) {
          if (data.isExpired) {
            let errors = []
            errors.push(t[language].InvalidIdentificationCodeExpired)
            this.setState({ errorMessage: errors, isValid: false })
            return false
          }
          if (data.isValid === false) {
            let errors = []
            errors.push(t[language].InvalidIdentificationCodeInvalid)
            this.setState({ errorMessage: errors, isValid: false })
            return false
          }
          if (data.isVerified === false) {
            let errors = []
            errors.push(t[language].InvalidIdentificationCodeInvalid)
            this.setState({ errorMessage: errors, isValid: false })
            return false
          }
          if (data.isExpired === false && data.isVerified === true) {
            let TOSAgree = this.authService.getProfile().Account_TOS_Agree
            window.localStorage.setItem('isDFAVerified', 1)
            if (TOSAgree === 0) {
              if (window.location.pathname !== '/myAccount') {
                window.location.href = '/myAccount'
              }
            } else {
              window.location.href = '/welcome'
            }
          }
        } else {
          let errors = []
          errors.push(t[language].internalservererror)
          this.setState({ errorMessage: errors, isValid: false })
          return false
        }
      })
    }
  }
  renderDFAform () {
    const language = this.state.currentLanguage
    return (
      <div className='dfa'>
        <div className='errorMessages'>
          <div className={'alert alert-danger errors ' + (this.state.isValid ? 'hide' : 'show')} >
            <ul>
              <PopulateError errors={this.state.errorMessage} />
            </ul>
          </div>
        </div>
        <form>
          <div className='top-text'>
            <p>{t[language].IdentificationCodeToolTip}<br /><strong>{this.state.maskedEmail}</strong></p>
          </div>
          <div className='middle-text'>
            <span className='id_label'>{t[language].IdentificationCodeLabel}:
            </span>
            <span>
              <a className='inline-block' data-tip={t[language].tempIdentification}><span className='tip openTip'>?</span></a>
              <ReactTooltip place='right' type='dark' effect='solid' />
            </span>
            <input className='inputmargin' type='text' name='DFACode' onChange={this.handleChange.bind(this)} />
          </div>
          <div className='buttonHolder'>
            <input type='button' value={t[language].DFASubmitVerification} onClick={this.submit.bind(this)} />
          </div>
        </form>
      </div>
    )
  }
  render () {
    return (
      <div>
        {this.renderDFAform()}
      </div>
    )
  }
}
export default LoginDFA



// WEBPACK FOOTER //
// ./src/components/Security/LoginDFA.js